/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Interest_Pre_IpoInputs */

const en_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pre-IPO (OpenAI, Anthropic)`)
};

const de_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor dem Börsengang (OpenAI, Anthropic)`)
};

const pt_br2_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pré-IPO (OpenAI, Anthropic)`)
};

const tr_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halka arz öncesi (OpenAI, Anthropic)`)
};

const zh_cn2_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上市前投资（OpenAI、Anthropic）`)
};

const zh_hk2_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上市前投資（OpenAI、Anthropic）`)
};

const ko_kr2_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상장 전 투자(OpenAI, Anthropic)`)
};

const ru_ru2_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`До IPO (OpenAI, Anthropic)`)
};

const es_419_onboarding_v1_interest_pre_ipo = /** @type {(inputs: Onboarding_V1_Interest_Pre_IpoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Antes de la salida a bolsa (OpenAI, Anthropic)`)
};

/**
* | output |
* | --- |
* | "Pre-IPO (OpenAI, Anthropic)" |
*
* @param {Onboarding_V1_Interest_Pre_IpoInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_interest_pre_ipo = /** @type {((inputs?: Onboarding_V1_Interest_Pre_IpoInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Interest_Pre_IpoInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "de") return de_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "tr") return tr_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_interest_pre_ipo(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_interest_pre_ipo(inputs)
	return es_419_onboarding_v1_interest_pre_ipo(inputs)
});